/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

import storage from '@/store/storage'

Vue.use(Vuex)

let token = ''
let areaId = ''

try {
  token = storage.get('token') || ''
  areaId = storage.get('areaId') || ''
} catch (e) {
  console.error(e)
}
// 测试
if (!token && process.env.NODE_ENV=='development') {
  token = 'eyJhbGciOiJIUzUxMiJ9.eyJyYW5kb21LZXkiOiJ3dnNtdHkiLCJzdWIiOiJ3ZWImJiYxIiwiYXJlYUlkIjoiNDMxMDAwIiwib2ZmaWNlSWQiOiJyb290IiwiZXhwIjoxNzE4MTg2MzcxLCJpYXQiOjE3MTc1ODE1NzF9.GfcVelo2dvgznMj9BJVp900zHKggntaJtraJnzNJMoj4Jj9BIE8pcfA0ibVEMUzb1YEdDtE8MGHm9XKFu0SMKA'
}
export default new Vuex.Store({
  state: {
    token,
    current: {},
    managerInfo: {},
    areaId,
    areaList: [],
  },
  mutations: {
    login(state: any, token: string) {
      state.token = token
      storage.set('token', token)
    },
    logout(state: any) {
      state.token = null
      state.current = null
      storage.remove('token')
    },
    setCurrent(state: any, current: any) {
      state.current = current
    },
    setManagerInfo(state: any, managerInfo: any) {
      state.managerInfo = managerInfo
    },
    setAreaId(state: any, areaId: string) {
      state.areaId = areaId
      if(areaId) storage.set('areaId', areaId)
      else storage.remove('areaId')
    },
    setAreaList(state: any, areaList: any[]) {
      state.areaList = areaList
    },
  },
  modules: {
  }
})
